export enum CustomerStatusEnum {
  Active = 'Active',
  Blocked = 'Blocked',
}

export const UnSubcribeStatus = {
  Subscribed: `false`,
  Unsubscribed: `true`,
}
export enum CustomerRegistedByEnum {
  Admin = 'Admin',
  CSV = 'CSV data',
  Customer = 'Customer',
}
